import React from 'react';

import styles from './ProductInquireDescription.module.css';

type Props = {
  question: string;
  answer?: string;
  onEdit?(): void;
  onDelete?(): void;
  allowEdit?: boolean;
  hideAction?: boolean;
};
function ProductInquireDescription({
  question,
  answer,
  allowEdit,
  hideAction,
  onEdit,
  onDelete,
}: Props) {
  return (
    <div>
      <div className={styles.content}>
        <span className={styles.mark}>Q.</span>
        {question}

        {answer && (
          <div className={styles.answer}>
            <span className={styles.mark}>A.</span>
            {answer}
          </div>
        )}
      </div>

      {!hideAction && (
        <div className={styles.footer}>
          {allowEdit && (
            <>
              <button type="button" className={styles.action} onClick={onEdit}>
                수정
              </button>
              <span className={styles.divider}>|</span>
            </>
          )}

          <button type="button" className={styles.action} onClick={onDelete}>
            삭제
          </button>
        </div>
      )}
    </div>
  );
}

export default ProductInquireDescription;
